import { useBackendApi } from './backendApi';
import { useEventsPublisher, useEventsSubscriber } from 'event-bus';
import { useCacheService } from './cacheService';
import { ProjectType, ProjectStatus } from './Types';

export interface UpdateMapEntryRequest {
  fubStageId: number;
}


export interface StatusMap {
  [key: string]: number | null;
}

export const FUB_STATUS_MAP_UPDATED = 'FUB_STATUS_MAP_UPDATED';

export const FUB_STATUS_MAP_CACHE_KEY = 'fubStatusMap';

export function useFubStatusMapService() {
  const nekstApi = useBackendApi();
  const cacheService = useCacheService('fubStatusMapService');
  const eventsPublisher = useEventsPublisher();

  useEventsSubscriber('fubStatusMapService', {
    [FUB_STATUS_MAP_UPDATED]: () => {
      cacheService.clear(FUB_STATUS_MAP_CACHE_KEY);
    }
  }, []);

  const getMap = async (profileId: number, projectType: ProjectType): Promise<StatusMap> => {
    return await nekstApi.get(`/integrations/profiles/${profileId}/fubstatusmap/${projectType}`) as StatusMap;
  };

  const updateMapEntry = async (
    profileId: number,
    projectType: ProjectType,
    projectStatus: ProjectStatus,
    request: UpdateMapEntryRequest
  ): Promise<void> => {
    await nekstApi.put(
      `/integrations/profiles/${profileId}/fubstatusmap/${projectType}/${projectStatus}`,
      request
    );
    eventsPublisher.publish(FUB_STATUS_MAP_UPDATED, {});
  };

  return {
    getMap,
    updateMapEntry,
  };
}
